import * as React from "react";
import { useEffect } from "react";
import PropTypes from "prop-types";
import TextInsertion from "./TextInsertion";
import { makeStyles } from "@fluentui/react-components";
import { insertFormValues } from "../taskpane";
import i18n from "../../../i18n";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const App = (props) => {
  const styles = useStyles();

  useEffect(() => {
    // Detect Outlook language
    const userLocale = Office.context.displayLanguage;
    const language = userLocale.split("-")[0]; // Get language code (e.g., "de")
    i18n.changeLanguage(language); // Change language dynamically
  }, []);

  return (
    <div className={styles.root}>
      <TextInsertion insertFormValues={insertFormValues} />
    </div>
  );
};

App.propTypes = {
  title: PropTypes.string,
};

export default App;
